//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
import { connect } from "react-redux";
// import ReactTooltip from 'react-tooltip';
// selection-scheduler imports
import { IProps, IContainer, IState } from "./ProfileUserSummary.d";
import * as s from "./ProfileUserSummary.styles";
// other components
import { AvatarPerson } from "@components/avatar";
import { CalendarStatus } from "@components/calendar-status";
import { LogoClock } from "@components/logo";
import { H2 } from "@ui";
// other internals
// util
// import { PostMessageManager } from '@util/post-message.util';
// import { TrackingEvents, track } from '@util/analytics.util';
// import { ChromeSite, getChromeSite } from '@util/chrome-extension.util';
// state
import { snackBarOpen } from "@actions/snack-bar.actions";
import { IReduxState } from "@reducers/root.reducer";
// material-ui
// import spacing from '@clockwise/web-commons/src/styles/spacing.styles';
// import Button from '@material-ui/core/Button';
// import EventAvailable from '@material-ui/icons/EventAvailable';

//////////////////
// COMPONENT
//////////////////
class ProfileUserSummaryComponent extends React.Component<IProps, IState> {
  // private lastCalendarSelections: string[] = [];
  // private toolTipId: string;

  constructor(props: IProps) {
    super(props);
    // this.toolTipId = `tooltip_for_profile_user_summary`;

    this.state = {
      toggled: false,
      sendingInvite: false,
      sentInvite: false,
    };
  }

  // private onClickViewCalendar = () => {
  //   const { calendarId } = this.props;

  //   const toggled = !this.state.toggled;
  //   this.setState({
  //     toggled,
  //   });

  //   let selected = this.lastCalendarSelections;
  //   if (toggled) {
  //     // remember selection state now
  //     const calSelectionStates = this.props.calendarSelectionStates;
  //     this.lastCalendarSelections = Object.keys(calSelectionStates).filter(calId => !!calSelectionStates[calId]);
  //     selected = [calendarId];
  //   }
  //   PostMessageManager.setCalendarSelections(selected, toggled); // force add on click
  //   track(TrackingEvents.TEAM_HEALTH.TOGGLE_CALENDAR, { calendarId, toggled });
  // }

  // private getTooltipContent = () => {
  //   const { org } = this.props;
  //   const { toggled } = this.state;
  //   const person = this.getPerson();
  //   const givenName = person && person.profile && person.profile.givenName || org.collaboratorStatsErrorable &&
  //     org.collaboratorStatsErrorable.__typename !== 'GraphEntityError' && org.collaboratorStatsErrorable.calendarId;
  //   const tooltip = toggled
  //     ? (<div style={{ textAlign: 'center' }}>Hide {givenName}'s calendar<br />and show others</div>)
  //     : (<div style={{ textAlign: 'center' }}>Show {givenName}'s calendar<br />and hide others</div>);

  //   return tooltip;
  // }

  private getPerson() {
    if (this.props.org.personsByCalendarIdsErrorable.__typename === "GraphEntityError") {
      return null;
    }
    const personList = this.props.org.personsByCalendarIdsErrorable.list;
    if (!personList.length) {
      return null;
    }

    return personList[0];
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderInviteStatus = (person: ISchema.IPerson | null) => {
    if (!person || person.isYou) {
      return <span />;
    }

    if (person.isUser) {
      return (
        <div style={s.joinLabel}>
          <LogoClock {...s.logo} />
          <div style={{ marginLeft: 5 }}>{person.profile.givenName} is using Clockwise</div>
        </div>
      );
    }

    return null;
  };

  public render() {
    const { org, calendarId } = this.props;
    // const { toggled } = this.state;

    const person = this.getPerson();

    const calendarStatus =
      org.calendarStatusErrorable.__typename !== "GraphEntityError"
        ? org.calendarStatusErrorable
        : null;
    let profileTimeZone = null;
    if (
      org.profileTimeZonesErrorable.__typename !== "GraphEntityError" &&
      org.profileTimeZonesErrorable.list.length
    ) {
      profileTimeZone = org.profileTimeZonesErrorable.list[0];
    }

    const displayName =
      !!person && person.profile && person.profile.givenName && person.profile.familyName
        ? `${person.profile.givenName} ${person.profile.familyName}`
        : this.props.calendarId;
    // const label = toggled ? 'Hide calendar' : 'Show calendar';

    // const chromeSite = getChromeSite();

    return (
      <div style={s.container}>
        <AvatarPerson
          person={person}
          orgPerson={null}
          size="xlarge"
          backupCalendarId={calendarId}
          showUserBadge
        />
        <H2 style={s.title}>{displayName}</H2>
        <div style={s.email}>{calendarId}</div>
        <CalendarStatus
          calendarStatus={calendarStatus}
          profileTimeZone={profileTimeZone}
          person={person}
          calendarId={calendarId}
        />
        {/* TODO: maybe get this working again?
          chromeSite === ChromeSite.Gcal
          ? <div style={s.btnContainer} data-for={this.toolTipId} data-tip>
              <Button
                variant="outlined"
                fullWidth={true}
                onClick={() => this.onClickViewCalendar()}
              >
                <EventAvailable style={{ marginRight: spacing.sm }} />
                {label}
              </Button>
              <ReactTooltip id={this.toolTipId} getContent={() => this.getTooltipContent()} />
            </div>
          : '' */}
        <div style={{ ...s.btnContainer, marginTop: 12 }}>{this.renderInviteStatus(person)}</div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    calendarSelectionStates: state.webExtension.calendarSelectionStates,
  };
}

const reduxContainer = connect(mapStateToProps, {
  snackBarOpen,
})(ProfileUserSummaryComponent);

//////////////////
// RELAY
//////////////////
import { fragments } from "./ProfileUserSummary.gql";
export const ProfileUserSummary = createFragmentContainer<IContainer>(reduxContainer, fragments);
